module.exports = __webpack_public_path__ + "img/news_05.bccda79b.jpg";